import { useCallback } from "react";

import { CarrierVoluntellActivationPageRouter } from "./CarrierVoluntellActivationPageRouter";
import { ShipperVoluntellActivationPageRouter } from "./ShipperVoluntellActivationPageRouter";
import { useAuthContext } from "../../../../../hooks";

import type { ActivationPageProps } from "../types";

interface VoluntellActivationPageRouterProps extends ActivationPageProps {
  onMetadataReady?: (metadata: Record<string, string>) => void;
}

export function VoluntellActivationPageRouter(
  props: VoluntellActivationPageRouterProps,
) {
  const { passwordField, submitButton, errorMessage, onMetadataReady } = props;

  const { user } = useAuthContext();
  const shipperRole = user?.roles?.find((r) => r.type === "SHIPPER");
  const roleType: RoleValue = shipperRole ? "SHIPPER" : "CARRIER";

  const handleMetadataReady = useCallback(
    (childMetadata: Record<string, string>) => {
      onMetadataReady?.({
        ...childMetadata,
        roleType,
      });
    },
    [onMetadataReady, roleType],
  );

  const pageProps = {
    passwordField,
    submitButton,
    errorMessage,
    onMetadataReady: handleMetadataReady,
  };

  if (roleType === "SHIPPER") {
    return <ShipperVoluntellActivationPageRouter {...pageProps} />;
  }

  return <CarrierVoluntellActivationPageRouter {...pageProps} />;
}
